import { Button } from "@faire/web--source/slate/Button";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import isChromatic from "chromatic/isChromatic";
import styled, { css, keyframes } from "styled-components";
var SWITCH_TIME = 5;
var ROTATING_WORDS_LENGTH = 5;
var TOTAL_LENGTH = ROTATING_WORDS_LENGTH * SWITCH_TIME;
var FINISH_FADE_IN = 0.1 * SWITCH_TIME;
var START_FADE_OUT = 0.9 * SWITCH_TIME;
var FINISH = 1.0 * SWITCH_TIME;
var POST_FINISH = 1.1 * SWITCH_TIME;
var FINISH_FADE_IN_PCT = (FINISH_FADE_IN / TOTAL_LENGTH * 100).toFixed(2);
var START_FADE_OUT_PCT = (START_FADE_OUT / TOTAL_LENGTH * 100).toFixed(2);
var FINISH_PCT = (FINISH / TOTAL_LENGTH * 100).toFixed(2);
var POST_FINISH_PCT = (POST_FINISH / TOTAL_LENGTH * 100).toFixed(2);
var rotateImages = keyframes([
    "0%{opacity:0;visibility:hidden;transform:translateY(30px);-webkit-animation:translateY(30px);-ms-transform:translateY(30px);}",
    "%{opacity:1;visibility:visible;transform:translateY(0px);-webkit-animation:translateY(0px);-ms-transform:translateY(0px);}",
    "%{opacity:1;visibility:visible;transform:translateY(0px);-webkit-animation:translateY(0px);-ms-transform:translateY(0px);}",
    "%{opacity:0;visibility:hidden;transform:translateY(-30px);-webkit-animation:translateY(-30px);-ms-transform:translateY(-30px);}",
    "%{opacity:0;visibility:hidden;transform:translateY(30px);-webkit-animation:translateY(30px);-ms-transform:translateY(30px);}"
], FINISH_FADE_IN_PCT, START_FADE_OUT_PCT, FINISH_PCT, POST_FINISH_PCT);
var rotateWords = keyframes([
    "0%{opacity:0;visibility:hidden;transform:translateY(30px);-webkit-animation:translateY(30px);-ms-transform:translateY(30px);}",
    "%{opacity:1;visibility:visible;transform:translateY(0px);-webkit-animation:translateY(0px);-ms-transform:translateY(0px);}",
    "%{opacity:1;visibility:visible;transform:translateY(0px);-webkit-animation:translateY(0px);-ms-transform:translateY(0px);}",
    "%{opacity:0;visibility:hidden;transform:translateY(-30px);-webkit-animation:translateY(-30px);-ms-transform:translateY(-30px);}",
    "%{opacity:0;visibility:hidden;transform:translateY(30px);-webkit-animation:translateY(30px);-ms-transform:translateY(30px);}"
], FINISH_FADE_IN_PCT, START_FADE_OUT_PCT, FINISH_PCT, POST_FINISH_PCT);
var WORD_PERFECT_POSITIONING = [
    "57px",
    "89px",
    "44px",
    "98px",
    "92px"
];
var animateWordPerfect = keyframes([
    "0%{left:",
    ";}17.5%{left:",
    ";}20%{left:",
    ";}37.5%{left:",
    ";}40%{left:",
    ";}57.5%{left:",
    ";}60%{left:",
    ";}77.5%{left:",
    ";}80%{left:",
    ";}97.5%{left:",
    ";}100%{left:",
    ";}"
], WORD_PERFECT_POSITIONING[0], WORD_PERFECT_POSITIONING[0], WORD_PERFECT_POSITIONING[1], WORD_PERFECT_POSITIONING[1], WORD_PERFECT_POSITIONING[2], WORD_PERFECT_POSITIONING[2], WORD_PERFECT_POSITIONING[3], WORD_PERFECT_POSITIONING[3], WORD_PERFECT_POSITIONING[4], WORD_PERFECT_POSITIONING[4], WORD_PERFECT_POSITIONING[0]);
var imageAnimationCSS = css([
    "visibility:hidden;opacity:0;animation:",
    " ",
    "s linear infinite ",
    "s;-webkit-animation:",
    " ",
    "s linear infinite ",
    "s;-ms-animation:",
    " ",
    "s linear infinite ",
    "s;"
], rotateImages, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
}, rotateImages, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
}, rotateImages, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
});
export var AnimatedImageSection = styled.div.withConfig({
    componentId: "sc-de313de-0"
})([
    "position:absolute;left:0;top:0;width:100%;height:100%;overflow:hidden;",
    ""
], isChromatic() ? "" : imageAnimationCSS);
var linkAnimationCss = css([
    "visibility:hidden;opacity:0;animation:",
    " ",
    "s linear infinite ",
    "s;-webkit-animation:",
    " ",
    "s linear infinite ",
    "s;-ms-animation:",
    " ",
    "s linear infinite ",
    "s;"
], rotateWords, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
}, rotateWords, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
}, rotateWords, TOTAL_LENGTH, function(param) {
    var $index = param.$index;
    return $index * SWITCH_TIME;
});
export var RotatingLink = styled(Button).attrs({
    variant: "tertiary"
}).withConfig({
    componentId: "sc-de313de-1"
})([
    "position:absolute;text-decoration-thickness:0.1em;left:",
    ";display:inline;width:100%;",
    "{width:unset;}overflow:hidden;&:hover{text-decoration-thickness:0.1em;}",
    ""
], function(props) {
    var _props_$linkPositioning;
    var _props_$linkPositioning_props_$index;
    return (_props_$linkPositioning_props_$index = (_props_$linkPositioning = props.$linkPositioning) === null || _props_$linkPositioning === void 0 ? void 0 : _props_$linkPositioning[props.$index]) !== null && _props_$linkPositioning_props_$index !== void 0 ? _props_$linkPositioning_props_$index : 0;
}, responsiveMediaQueries.xLargeAndAbove, isChromatic() ? "" : linkAnimationCss);
export var BannerContentTypography = styled(Typography).attrs({
    variant: {
        mobileAndAbove: "displayMSerifRegular",
        desktopAndAbove: "displayLSerifRegular"
    }
}).withConfig({
    componentId: "sc-de313de-2"
})([
    ""
]);
export var NonEngContentWrapper = styled.div.withConfig({
    componentId: "sc-de313de-3"
})([
    'display:grid;place-items:center;grid-template-areas:"non-eng-content";padding:',
    ";width:100%;",
    "{max-width:430px;}",
    "{width:100%;max-width:650px;}text-align:center;"
], getSpacing("4x"), responsiveMediaQueries.tabletAndAbove, responsiveMediaQueries.xLargeAndAbove);
export var RotatingNonEngContent = styled(BannerContentTypography).withConfig({
    componentId: "sc-de313de-4"
})([
    "display:inline;overflow:hidden;visibility:hidden;opacity:0;width:100%;",
    "{width:unset;}animation:",
    " ",
    "s linear infinite ",
    "s;-webkit-animation:",
    " ",
    "s linear infinite ",
    "s;-ms-animation:",
    " ",
    "s linear infinite ",
    "s;position:relative;grid-area:non-eng-content;"
], responsiveMediaQueries.xLargeAndAbove, rotateWords, TOTAL_LENGTH, function(param) {
    var index = param.index;
    return index * SWITCH_TIME;
}, rotateWords, TOTAL_LENGTH, function(param) {
    var index = param.index;
    return index * SWITCH_TIME;
}, rotateWords, TOTAL_LENGTH, function(param) {
    var index = param.index;
    return index * SWITCH_TIME;
});
export var AnimatedWordPerfect = styled.div.withConfig({
    componentId: "sc-de313de-5"
})([
    "width:100%;text-align:center;",
    "{width:unset;position:absolute;overflow:hidden;display:inline;}animation:",
    " ",
    "s linear infinite;"
], responsiveMediaQueries.xLargeAndAbove, animateWordPerfect, TOTAL_LENGTH);
